import core from './core';
import counters from './counters';
import overview from './overview';

export default {
    core,
    counters,
    overview,
};
